module.exports = __webpack_public_path__ + "img/magic-wand-02.2a9fcdca.svg";